module.exports = __webpack_public_path__ + "img/m-bg2.589a87e7.jpg";